import { takeEvery, put, call } from "redux-saga/effects"

import {
  GET_CUSTOMER_SERVICE,
  ADD_CUSTOMER_SERVICE,
  UPDATE_CUSTOMER_SERVICE,
  DELETE_CUSTOMER_SERVICE,
} from "./actionTypes"

import {
  getCustomerServiceSuccess,
  getCustomerServiceFail,
  addCustomerServiceSuccess,
  addCustomerServiceFail,
  updateCustomerServiceSuccess,
  updateCustomerServiceFail,
  deleteCustomerServiceSuccess,
  deleteCustomerServiceFail,
  showLoading,
  hideLoading,
} from "./actions"

import {
  getCustomerService,
  addNewCustomerService,
  updateCustomerService,
  deleteCustomerService,
} from "../../helpers/backend_helper"

import { showToast } from "../../components/Toast"

function* fetchCustomerService() {
  try {
    yield put(showLoading(true))
    const response = yield call(getCustomerService)
    yield put(getCustomerServiceSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getCustomerServiceFail(error))
  }
}

function* onAddNewCustomerService({ payload: custService }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addNewCustomerService, custService)
    showToast("New Problem is added")
    yield put(addCustomerServiceSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addCustomerServiceFail(error.response))
  }
}

function* onUpdateCustomerService({ payload: custService }) {
  try {
    yield put(showLoading(true))

    const response = yield call(updateCustomerService, custService)
    showToast("Changes Successfully Applied")
    yield put(updateCustomerServiceSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateCustomerServiceFail(error))
  }
}

function* onDeleteCustomerService({ payload: custService }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteCustomerService, custService)
    showToast("Problem is deleted from the system")
    yield put(deleteCustomerServiceSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteCustomerServiceFail(error))
  }
}

// function* fetchManagers() {
//   try {
//     const response = yield call(getManagers)
//     yield put(getManagersSuccess(response))
//   } catch (error) {
//     yield put(getManagersFail(error))
//   }
// }

function* customerServiceSaga() {
  yield takeEvery(GET_CUSTOMER_SERVICE, fetchCustomerService)
  yield takeEvery(ADD_CUSTOMER_SERVICE, onAddNewCustomerService)
  yield takeEvery(UPDATE_CUSTOMER_SERVICE, onUpdateCustomerService)
  yield takeEvery(DELETE_CUSTOMER_SERVICE, onDeleteCustomerService)
  // yield takeEvery(GET_MANAGERS, fetchManagers)
}

export default customerServiceSaga
